import { render, staticRenderFns } from "./StudentExcelUpload.vue?vue&type=template&id=6591438c&"
import script from "./StudentExcelUpload.vue?vue&type=script&lang=ts&"
export * from "./StudentExcelUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports